import { useState } from "react";
import { GetOperationType } from "../../../models/_tickets";
import { SiteVisitationSteps, useSiteVisitation } from "../../../providers/SiteVisitationProvider";
import FlavorPrices from "./FlavorPrices";
import LocationChecks from "./LocationChecks";
import MarketingMaterials from "./MarketingMaterials";
import Operation from "./Operation";

export const LocationInfo = (props: { locationName: string,values: any; setFieldValue: any; jobId: any, setCurrentStep: (step: number) => void; }) => {

    const { locationName, values, setFieldValue, jobId, setCurrentStep } = props;
    const { flavors } = useSiteVisitation();
    const [errors, setErrors] = useState<string[]>([]);
    const validateFlavorPrices = () => {
        setErrors([]);
        const flavorPrices = values.flavorPrices || [];
        const invalidFlavors = flavorPrices.filter((item: any) => item.is_active && (!item.price || String(item.price).trim() === ""));
        if (invalidFlavors.length > 0) {
            const errorMessages = invalidFlavors.map((item: any) => {
                const flavorName =
                  flavors.find((f: any) => f.flavor === item.flavor)?.name || "";
          
                return `Flavor ${flavorName} price is required.`;
              });
            setErrors(errorMessages);
            return false;
        }
        setCurrentStep(SiteVisitationSteps.LOCATION_INFO_2)
        return true;
    };
    return (<div className="wo-form-section mt-8">
        <header className="header">
            <h2>Location Information</h2>
        </header>
        <div
            className="left-icon m-4 mt-4"
            onClick={() => setCurrentStep(SiteVisitationSteps.MACHINE_LIST)}
        >
            <i
                className="fa fa-arrow-left"
                aria-hidden="true"
            ></i>
        </div>
        <div className="machine-wrapper">
            <p className="">
                <strong>Location Name:</strong>{" "}
                {locationName}
            </p>
            <Operation
                jobId={jobId}
            />
            <MarketingMaterials
                jobId={jobId}
            />
            <FlavorPrices
                jobId={jobId}
                values={values}
                setFieldValue={setFieldValue}
                flavors={flavors}
            />
            <LocationChecks
                jobId={jobId}
                values={values}
                setFieldValue={setFieldValue}
            />
            <button type="button" className="btn btn-primary float-end " onClick={() => validateFlavorPrices()}>Next  <i className="fa fa-arrow-right ms-2" aria-hidden="true"></i></button>

           
        </div>
        <div className="error-messages">
             {errors.length > 0 && (
          <div className="alert alert-danger mt-4 mb-3 p-3 border border-danger rounded">
            <strong>Please complete required fields for the following:</strong>
            <ul className="mt-2 mb-0 ps-4">
              {errors.map((name, index) => (
                <li key={index}>{name}</li>
              ))}
            </ul>
          </div>
        )}
            </div>
    </div>)
}